import { __awaiter } from '../../_virtual/_tslib.js';
import { useQueryClient, useQuery, useMutation } from 'react-query';
import { BID_UPDATE_TYPE } from '../../constants/bidUpdateType.js';
import '../../constants/authorizedUsers.js';
import '../../constants/bidStatus.js';
import '../../constants/bulkLoadCardStatus.js';
import '../../constants/misc.js';
import '../../constants/event-names.js';
import '../../constants/eventsMapObj.js';
import '../../constants/Faq.js';
import '../../constants/languages.js';
import '../../constants/loadStatus.js';
import '../../constants/lorryStatus.js';
import '../../constants/lorryTypes.js';
import '../../constants/mostSearchedLinks.js';
import '../../constants/Pages.js';
import 'react';
import '../../constants/serviceTypeId.js';
import '../../constants/StateList.js';
import '../../constants/userAction.js';
import '../../constants/api.js';
import '../../constants/link.js';
import '../../constants/market.js';
import '../../constants/payment.js';
import '../../constants/admin/screenId.js';
import API from '../const.js';
import 'bowser';
import { sleep } from '../../methods/sleep.js';
import '../../components/toast/toast.js';
import '../auth.service.js';
import { getAuthIdParam } from '../../methods/getAuthIdParam.js';
import 'react-cookie';
import '../../methods/formatDate.js';
import '../../methods/getTransporterFigure.js';
import '../../methods/getDownloadsFigure.js';
import 'lodash.isequal';
import '../../methods/getPageLoadSourceUTMParam.js';
import 'crypto-js';
import { getAuthHeader } from '../utils/getAuthHeader.js';
import { handleMutateResponse } from '../utils/handleMutateResponse.js';
import { QueryNames } from './queryNames.js';

function useGetTransactionListService(mktType, queryParams, options) {
    const queryClient = useQueryClient();
    const { loadId, bidderId, companyId, lorryId, notificationId } = queryParams;
    const apiClient = mktType === "load"
        ? API.LOAD_TRANSACTION_LIST +
            getAuthIdParam() +
            "&l_i=" +
            loadId +
            "&b_i=" +
            bidderId +
            "&c_i=" +
            companyId +
            "&lr_i=" +
            lorryId +
            "&n_i=" +
            notificationId
        : API.LORRY_TRANSACTION_LIST +
            getAuthIdParam() +
            "&l_i=" +
            lorryId +
            "&b_i=" +
            bidderId +
            "&c_i=" +
            companyId +
            "&ld_i=" +
            loadId +
            "&n_i=" +
            notificationId;
    return useQuery([QueryNames.bidTransaction, ...Object.values(queryParams)], () => fetch(apiClient, {
        method: "GET",
        headers: Object.assign({ Accept: "application/json", "Content-Type": "application/json" }, getAuthHeader())
    }).then((res) => {
        if (res.status === 401) {
            queryClient.invalidateQueries();
            return;
        }
        else {
            return res.json().then((jsonData) => {
                const allData = jsonData.data;
                return allData;
            });
        }
    }), {
        enabled: options === null || options === void 0 ? void 0 : options.enabled,
        onSuccess: options === null || options === void 0 ? void 0 : options.onSuccess,
        onError: options === null || options === void 0 ? void 0 : options.onError,
        refetchInterval: options === null || options === void 0 ? void 0 : options.refetchInterval
    });
}
// To Update Bid
function useUpdateBidService(mktType) {
    const queryClient = useQueryClient();
    const apiClient = (mktType === "load" ? API.LOAD_TRANSACTION_ACCEPT_OR_REJECT_BID : API.LORRY_TRANSACTION_ACCEPT_OR_REJECT_BID) +
        getAuthIdParam();
    // Removed data and error props to remove warning, can be added when need
    const { isLoading, isError, isSuccess, mutateAsync } = useMutation(({ lastBidId, amount, requestType }) => fetch(apiClient, {
        method: "POST",
        headers: Object.assign({}, getAuthHeader()),
        body: JSON.stringify({
            bid_id: lastBidId,
            amount,
            type: requestType
        })
    }), {
        onSuccess: (res) => {
            if (res.status === 401) {
                queryClient.invalidateQueries(QueryNames.validateToken);
            }
            if (res.status === 200) {
                queryClient.invalidateQueries([QueryNames.bidTransaction]);
            }
        }
    });
    return { isLoading, isError, isSuccess, mutateAsync };
}
function handleSubmitUpdateBidResponse(mutateFn, updateBidParams) {
    return __awaiter(this, void 0, void 0, function* () {
        return handleMutateResponse(mutateFn, updateBidParams);
    });
}
function useAcceptOrRejectBidService({ mktType }) {
    const queryClient = useQueryClient();
    const apiClient = (mktType === "load" ? API.LOAD_TRANSACTION_ACCEPT_OR_REJECT_BID : API.LORRY_TRANSACTION_ACCEPT_OR_REJECT_BID) +
        getAuthIdParam();
    // Removed data and error props to remove warning, can be added when need
    const { isLoading, isError, isSuccess, mutateAsync } = useMutation(({ lastBidId, tenderer_comment }) => fetch(apiClient, {
        method: "POST",
        headers: Object.assign({}, getAuthHeader()),
        body: JSON.stringify({
            bid_id: lastBidId,
            tenderer_comment: tenderer_comment || "",
            type: BID_UPDATE_TYPE.ACCEPT
        })
    }), {
        onSuccess: (res) => __awaiter(this, void 0, void 0, function* () {
            if (res.status === 401) {
                queryClient.invalidateQueries(QueryNames.validateToken);
            }
            if (res.status === 200) {
                queryClient.invalidateQueries([QueryNames.bidTransaction]);
            }
        })
    });
    return { isLoading, isError, isSuccess, mutateAsync };
}
// Bidder reject receiver price - load transaction
function useBidderRejectBidService(mktType) {
    const { mutateAsync } = useAcceptOrRejectBidService({
        mktType
    });
    return { mutateAsync };
}
// Receiver accept bid - lorry transaction
function useReceiverAcceptBidService(mktType) {
    const { mutateAsync } = useAcceptOrRejectBidService({
        mktType
    });
    return { mutateAsync };
}
function handleAcceptOrRejectBidResponse(mutateFn, rejectBidParams) {
    return __awaiter(this, void 0, void 0, function* () {
        return handleMutateResponse(mutateFn, rejectBidParams);
    });
}
function handleNegotiateBidResponse(mutateRejectBid, rejectBidParams, mutateSubmitBid, submitBidParams) {
    return __awaiter(this, void 0, void 0, function* () {
        const { success } = yield handleMutateResponse(mutateRejectBid, rejectBidParams);
        if (success) {
            yield sleep(800);
            return yield handleMutateResponse(mutateSubmitBid, submitBidParams);
        }
        else {
            return { success };
        }
    });
}

export { handleAcceptOrRejectBidResponse, handleNegotiateBidResponse, handleSubmitUpdateBidResponse, useBidderRejectBidService, useGetTransactionListService, useReceiverAcceptBidService, useUpdateBidService };
//# sourceMappingURL=useTransactionService.js.map
